import React, { useState, useRef, useEffect } from 'react';
import { useTheme } from '../../context/ThemeContext';

export default function EditMessageForm({ message, onSave, onCancel }) {
    const { theme } = useTheme();
    const [content, setContent] = useState(message.content);
    const textareaRef = useRef(null);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.focus();
            textareaRef.current.selectionStart = textareaRef.current.value.length;
        }
    }, []);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (content.trim() && content.trim() !== message.content) {
                onSave(content.trim());
            }
        }
        if (e.key === 'Escape') {
            onCancel();
        }
    };

    return (
        <div className="w-full">
            <textarea
                ref={textareaRef}
                value={content}
                onChange={(e) => setContent(e.target.value)}
                onKeyDown={handleKeyDown}
                rows={2}
                className={`w-full px-3 py-2 rounded-lg text-sm font-rasa resize-none border ${
                    theme === 'dark'
                        ? 'bg-gray-700 border-gray-600 text-white'
                        : 'bg-white border-gray-300 text-gray-900'
                } focus:outline-none focus:ring-2 focus:ring-blue-500`}
            />
            <div className="flex items-center gap-2 mt-1 text-xs font-rasa">
                <span className={theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}>
                    Enter to save, Escape to cancel
                </span>
                <button
                    onClick={onCancel}
                    className={`px-2 py-0.5 rounded ${
                        theme === 'dark' ? 'hover:bg-gray-600 text-gray-400' : 'hover:bg-gray-200 text-gray-500'
                    }`}
                >
                    Cancel
                </button>
                <button
                    onClick={() => content.trim() && content.trim() !== message.content && onSave(content.trim())}
                    className="px-2 py-0.5 rounded bg-blue-500 text-white hover:bg-blue-600"
                >
                    Save
                </button>
            </div>
        </div>
    );
}
